<template>
  <div @keydown.enter="handleSubmit">
    <Form ref="loginForm" :model="phoneFormItem" :rules="rules">

      <FormItem prop="phoneNumber">
        <Input v-model="phoneFormItem.phoneNumber" disabled maxlength="11" placeholder="请输入手机号">
        <span slot="prepend">
          <Icon :size="16" type="md-phone-portrait" />
        </span>
        </Input>
      </FormItem>
      <FormItem prop="email" v-if="role === 'admin'">
        <Input v-model="phoneFormItem.email" placeholder="请输入邮箱">
        <span slot="prepend">
          <Icon :size="16" type="md-mail" />
        </span>
        </Input>
      </FormItem>
      <FormItem prop="code" class="codeItem">
        <Input v-model="phoneFormItem.code" maxlength="8" placeholder="请输入验证码">
        <span slot="prepend">
          <Icon :size="16" type="md-radio-button-on" />
        </span>
        </Input>
        <div class="phoneCode" v-if="role === 'admin'">
          <span v-show="showPcode" @click="getEmailCode" style="cursor: pointer;">获取验证码</span>
          <span v-show="!showPcode">{{count}} s</span>
        </div>
        <div class="phoneCode" v-else>
          <span v-show="showPcode" @click="getCode" style="cursor: pointer;">获取验证码</span>
          <span v-show="!showPcode">{{count}} s</span>
        </div>
      </FormItem>
      <FormItem class="loginBtn">
        <Button :loading="btnLoading" @click="handleSubmit" type="primary" long>登录</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  import api from "@/api";
  import ls from "store2";
  export default {
    name: "loginForm",
    props: {
      role: String,
      validPhone: String,
      btnLoading: Boolean,
      isLoadingFunc: Function
    },
    data() {
      return {
        showPcode: true,
        count: 60,
        agreement: false,
        phoneFormItem: {
          phoneNumber: this.validPhone,
          email: '',
          code: ''
        }
      };
    },
    computed: {
      rules() {
        return {
          phoneNumber: [{
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          }],
          email: [{
              required: true,
              message: '请填写邮箱',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: '请填写正确的邮箱',
              trigger: 'blur'
            }
          ],
          code: [{
            required: true,
            message: '请填写验证码',
            trigger: 'blur'
          }]
        };
      }
    },
    mounted() {},
    methods: {
      handleSubmit() {
        this.isLoadingFunc(true)
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.phoneFormItem.identity = this.role
            this.$emit("on-success-valid", this.phoneFormItem);
          }
        });
      },
      /**
       * 验证电子邮箱格式
       */
      email(value) {
        return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value);
      },
      getEmailCode() {
        let notEmail=this.email(this.phoneFormItem.email)
        //let notEmail = this.phoneFormItem.email.indexOf('.com') < 0 && this.phoneFormItem.email.indexOf('.cn') < 0 && this.phoneFormItem.email.indexOf('.net') < 0
        if (!notEmail) return this.$Message.info('请填写正确的邮箱');

        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showPcode = false;
          let datas = {
            email: this.phoneFormItem.email
          }
          api.axsl("post", "/ocm-auth/email-code", datas).then(res => {
            if (res.code === '00000') {
              this.$Message.success('验证码发送成功, 请前往邮箱查收');
            } else {
              this.$Message.error(res.msg);
            }
          })
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) { // 6.设置每秒钟递减
              this.count--;
            } else { // 7.递减至0时,显示获取验证码按钮,隐藏倒计时模块,清除定时器this.timer,并将其置为null
              this.showPcode = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      },
      getCode() {
        if (this.phoneFormItem.phoneNumber != '') { // 1.首先判断是否未输入手机号码就点击获取验证码
          // if (/^1[3456789]\d{9}$/.test(this.phoneFormItem.phoneNumber)) { //2.使用正则判断手机输入的验证码是否符合规范
            const TIME_COUNT = 60; // 3.设置时间为60s
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.showPcode = false; // 4.隐藏获取验证码按钮,展示倒计时模块
              this.getPhoneCode() // 5.调用后端获取验证码接口的函数
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) { // 6.设置每秒钟递减
                  this.count--;
                } else { // 7.递减至0时,显示获取验证码按钮,隐藏倒计时模块,清除定时器this.timer,并将其置为null
                  this.showPcode = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          // } else {
          //   this.$Message.error('手机号格式不正确');
          // }
        } else {
          this.$Message.error('请先填写手机号码');
        }
      },
      getPhoneCode() {
        let datas = {
          phoneNumber: this.phoneFormItem.phoneNumber
        }
        api.axsl("post", "/ocm-auth/sms-code", datas).then(res => {
          if (res.code === '00000') {
            this.$Message.success('验证码发送成功');
          }
        })
      },
    },
    // watch: {
    //     'validPhone': {
    //         handler: function(newValue, oldValue) {
    //             this.phoneFormItem.phoneNumber = newValue;
    //         },
    //         deep: true,
    //     },
    // }
  };
</script>
<style lang="less">
  .codeItem {
    position: relative;

    .phoneCode {
      position: absolute;
      top: 1px;
      right: 1px;
      z-index: 2;
      height: 30px;
      border-radius: 4px;
      padding: 0 10px;

      span {
        color: #0c479d
      }
    }
  }

  .loginBtn {
    margin: 30px 0 10px !important;
  }

  .agreeItem {
    .ivu-checkbox-wrapper {
      line-height: 20px;
      font-size: 12px;
    }
  }
</style>